<template>
  <div class="mediaintro">
    <b-container>
      <div class="media-bg"></div>
      <b-row>
        <b-col lg="6" md="12" sm="12" class="left">
          <LeftContent id="left-con" :heading="heading" :paragraph="paragraph" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import LeftContent from "../common/leftContent";
export default {
  name: "Mediaintro",
  props: ["heading", "paragraph"],
  components: {
    LeftContent,
  },
};
</script>
<style scoped>
.left {
  padding-left: 0;
}

@media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
  .left {
    padding-left: 10px;
  }
  #left-con {
    backdrop-filter: blur(10px);
    padding-left: 15px;
    background-color: rgba(255, 255, 255, 0);
    padding-right: 15px;
  }
}
@media (min-width: 481px) and (max-width: 767px) {
  .left {
    padding-left: 10px;
  }
  #left-con {
    backdrop-filter: blur(10px);
    padding-left: 15px;
    background-color: rgba(255, 255, 255, 0);
    padding-right: 15px;
  }
}
@media (max-width: 480px) {
  .left {
    padding-left: 10px;
  }
  #left-con {
    backdrop-filter: blur(4px);
    padding-left: 15px;
    background-color: rgba(255, 255, 255, 0);
    padding-right: 15px;
    border-radius: 20px;
  }
}
</style>
